import React from 'react';
import Textarea from 'react-textarea-autosize';
import FormFieldErrors from 'components/error/components/FormFieldErrors';
import { getFieldErrors } from 'helpers/errors';
import { useDebouncedField } from 'hooks';
export const AutosizeTextarea = ({ className, cols, debounceDelay, errors, id, input, inputRef, isDebounced, isDisabled, maxLength, meta, name, onBlur, onInputChange, placeholder, required, rows, style = {}, value = '', }) => {
    let fieldErrors;
    let hasErrors;
    let inputName;
    let handleOnBlur;
    const { onChange: handleOnChange, value: currentValue } = useDebouncedField({
        debounceDelay,
        isDebounced,
        input: input ||
            {
                onChange: onInputChange,
                value,
            },
    });
    if (input) {
        inputName = input.name;
        fieldErrors = meta.touched && meta.error;
        hasErrors = !!fieldErrors;
        handleOnBlur = input.onBlur;
    }
    else {
        inputName = name;
        fieldErrors = errors;
        hasErrors = !!getFieldErrors(errors, inputName);
        handleOnBlur = onBlur;
    }
    const widthClasses = [];
    const otherClasses = [];
    className.split(' ').forEach((cls) => {
        if (cls.startsWith('w-') || cls.startsWith('right')) {
            widthClasses.push(cls);
        }
        else {
            otherClasses.push(cls);
        }
    });
    if (hasErrors) {
        otherClasses.push('error');
    }
    if (isDisabled) {
        otherClasses.push('disabled');
    }
    return (React.createElement("div", { className: widthClasses.join(' ') },
        React.createElement("div", { className: otherClasses.join(' ') },
            React.createElement(Textarea, { cols: cols, disabled: isDisabled, id: id, inputRef: inputRef, maxLength: maxLength, name: inputName, onBlur: handleOnBlur, onChange: handleOnChange, placeholder: placeholder, required: required, rows: rows, style: style, value: currentValue || '' }),
            React.createElement("label", { htmlFor: inputName }, placeholder)),
        React.createElement(FormFieldErrors, { errors: fieldErrors, fieldName: inputName })));
};
